import { render, staticRenderFns } from "./ServicemanCars.vue?vue&type=template&id=025849a4&"
import script from "./ServicemanCars.vue?vue&type=script&lang=js&"
export * from "./ServicemanCars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports